/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriodConfig } from '../../models/program-period-config';

export interface CreateAdminProgramPeriodConfig$Params {
  body: ProgramPeriodConfig;
}

export function createAdminProgramPeriodConfig(
  http: HttpClient,
  rootUrl: string,
  params: CreateAdminProgramPeriodConfig$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
  const rb = new RequestBuilder(rootUrl, createAdminProgramPeriodConfig.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriodConfig>;
    })
  );
}

createAdminProgramPeriodConfig.PATH = '/admin/program-period-configs';
